import React, { useEffect, useState } from "react";
import {
  Card,
  Modal,
  Table,
  Tag,
  Button,
  Form,
  Input,
  Select,
  message,
  Spin,
  Row,
  Col,
  Statistic,
  DatePicker,
  Tooltip,
} from "antd";
import {
  WalletOutlined,
  RiseOutlined,
  CalendarOutlined,
  EditOutlined,
  ExpandAltOutlined,
  CompressOutlined,
  FilterOutlined,
  CloseCircleOutlined,
} from "@ant-design/icons";
import axios from "axios";
import { Base_Uri } from "../Constant/BaseUri";
import { ArrowDownward, ArrowDropDown } from "@mui/icons-material";
import { useSelector } from "react-redux";

const { TextArea } = Input;
const { RangePicker } = DatePicker;

const CashAdjustmentCard = ({setAdjustmentCloseChangeOver}) => {
  const [loading, setLoading] = useState(false);
  const [mainLoading, setMainLoading] = useState(true);
    const userData = useSelector((state) => state.loginReducer.updatedState);
  

  const [open, setOpen] = useState(false);
  const [editOpen, setEditOpen] = useState(false);

  const [lastData, setLastData] = useState(null);
  const [totalCash, setTotalCash] = useState(0);

  const [list, setList] = useState([]);
  const [selected, setSelected] = useState(null);
  const [isCollapsed, setIsCollapsed] = useState(true);
  const [dateRange, setDateRange] = useState([]);

  const [page, setPage] = useState(1);
  const [pagination, setPagination] = useState({
    totalRecords: 0,
    limit: 10,
  });

  const [form] = Form.useForm();

  // ===================== LOAD CARD =====================
  const loadTopData = async () => {
    let data = await sessionStorage.getItem("userData");
    data = JSON.parse(data);
    let token = data;
    try {
      const [lastRes, totalRes] = await Promise.all([
        axios.get(`${Base_Uri}amount/get?last_one=1`, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json", // Include other headers as needed
          },
        }),
        axios.get(`${Base_Uri}amount/get?is_total=1`, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json", // Include other headers as needed
          },
        }),
      ]);

      setLastData(lastRes.data.data);
      setTotalCash(totalRes.data.total_cash_have || 0);
    } catch (error) {
      console.log(error);
    } finally {
      setMainLoading(false);
    }
  };

  // ===================== LOAD TABLE =====================
  //   const loadList = async (current = 1) => {
  //      let data = await sessionStorage.getItem("userData");
  //     data = JSON.parse(data);
  //     let token = data;
  //     try {
  //       setLoading(true);

  //       const res = await axios.get(
  //         `${Base_Uri}amount/get?page=${current}&limit=10`,{
  //           headers: {
  //             Authorization: `Bearer ${token}`,
  //             "Content-Type": "application/json", // Include other headers as needed
  //           },
  //         }
  //       );

  //       setList(res.data.data);
  //       setPagination(res.data.pagination);
  //       setPage(current);
  //     } catch (error) {
  //       console.log(error);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  const loadList = async (current = 1, dates = dateRange) => {
    let data = await sessionStorage.getItem("userData");
    data = JSON.parse(data);
    let token = data;

    try {
      setLoading(true);

      let url = `${Base_Uri}amount/get?page=${current}&limit=10`;

      if (dates?.length === 2) {
        url += `&start_date=${dates[0].startOf("day").format("YYYY-MM-DD HH:mm:ss")}`;
        url += `&end_date=${dates[1].endOf("day").format("YYYY-MM-DD HH:mm:ss")}`;
      }

      const res = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      setList(res.data.data);
      setPagination(res.data.pagination);
      setPage(current);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const handleDateFilter = (dates) => {
    setDateRange(dates || []);
    loadList(1, dates || []);
  };

  useEffect(() => {
    loadTopData();
  }, []);

  const openModal = () => {
    setOpen(true);
    loadList(1);
  };

  // ===================== EDIT =====================
  const handleEdit = (row) => {
    setSelected(row);

    form.setFieldsValue({
      cash_have: row.cash_have,
      cash_at_point: row.cash_at_point,
      remarks: row.remarks,
      status: row.status ? "true" : "false",
    });

    setEditOpen(true);
  };

  const submitEdit = async () => {
    try {
      const values = await form.validateFields();
      let data = await sessionStorage.getItem("userData");
      data = JSON.parse(data);
      let token = data;

      await axios.put(
        `${Base_Uri}amount/update?item=${selected._id}`,
        {
          ...values,
          status: values.status === "true",
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json", // Include other headers as needed
          },
        },
      );

      message.success("Updated Successfully");
      setEditOpen(false);

      loadTopData();
      loadList(page);
    } catch (error) {
      console.log(error);
    }
  };

  // ===================== TABLE =====================
  const columns = [
    {
      title: "Emplooye name",
      dataIndex: "Emplooye_name",
    },
    {
      title: "Date",
      dataIndex: "createdAt",
      render: (val) => (
        <span style={{ fontWeight: 500 }}>
          {new Date(val).toLocaleString()}
        </span>
      ),
    },
    
    {
      title: "Cash Variance",
      dataIndex: "cash_have",
      render: (val) => (
        <span style={{ color: "#16a34a", fontWeight: 700 }}>
          £ {Number(val).toLocaleString()}
        </span>
      ),
    },
    {
      title: "Expected Cash",
      dataIndex: "cash_at_point",
      render: (val) => (
        <span style={{ color: "#1677ff", fontWeight: 600 }}>
          £ {Number(val).toLocaleString()}
        </span>
      ),
    },
    {
      title: "Notes",
      dataIndex: "remarks",
      render: (val) => val || "-",
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (val) =>
        val ? (
          <Tag color="success">Resolved</Tag>
        ) : (
          <Tag color="processing">Pending</Tag>
        ),
    },
    {
      title: "Action",
      render: (_, row) =>
        ((userData?.role_access?.length!=0&&userData.role_access?.some(role => 
  role?.subcategory && role?.subcategory?.some(sub => sub.name === "Edit Cash Adjustment" && sub.selected)
))||userData.role=="admin")?(!row.status ? (
          <Button
            type="primary"
            ghost
            icon={<EditOutlined />}
            onClick={() => handleEdit(row)}
          >
            Edit
          </Button>
        ) : (
          "-"
        )):"-",
    },
  ];

  return (
    <>
      {/* ================= MAIN CARD ================= */}
      <Card
        hoverable
        style={{
          width: "100%",
          borderRadius: 22,
          overflow: "hidden",
          cursor: "pointer",
          border: "none",
          boxShadow: "0 15px 45px rgba(0,0,0,0.12)",
          background:
            "#0F64B3",
        }}
        bodyStyle={{ padding: 22 }}
      >
        {/* Header */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: 18,
          }}
        >
          <div onClick={()=>((userData?.role_access?.length!=0&&userData.role_access?.some(role => 
  role?.subcategory && role?.subcategory?.some(sub => sub.name === "View History" && sub.selected)
))||userData.role=="admin")?openModal():()=>{}}>
            <h2 style={{fontSize:16, color: "#fff", margin: 0 }}>Day End Cash Variance</h2>
            <span style={{ color: "rgba(255,255,255,.75)" }}>
              Click to view history
            </span>
          </div>

          <div style={{gap:5,display:"flex",}}>
            <Tooltip title={isCollapsed ? "Expand" : "Collapse"}>
            <Button
              shape="circle"
              size="small"
              icon={isCollapsed ? <ExpandAltOutlined /> : <CompressOutlined />}
              onClick={(e) => {
                e.stopPropagation();
                setIsCollapsed(!isCollapsed);
              }}
            />
          </Tooltip>
          <Tooltip title={"Dismiss"}>
            <Button
              shape="circle"
              size="small"
              icon={<CloseCircleOutlined />}
              onClick={(e) => {
                e.stopPropagation();
                sessionStorage.setItem("Close","true")
                setAdjustmentCloseChangeOver(true)
              }}
            />
          </Tooltip>
          </div>
        </div>

        {mainLoading ? (
          <div style={{ textAlign: "center", padding: 20 }}>
            <Spin size="large" />
          </div>
        ) : (
          <>
            {/* Always show total */}
            <div
              onClick={()=>((userData?.role_access?.length!=0&&userData.role_access?.some(role => 
  role?.subcategory && role?.subcategory?.some(sub => sub.name === "View History" && sub.selected)
))||userData.role=="admin")?openModal():()=>{}}
              style={{
                padding: 16,
                borderRadius: 16,
                background: "rgba(255,255,255,0.14)",
                color: "#fff",
                cursor: "pointer",
              }}
            >
              <div style={{ opacity: 0.8 }}>Pending Extra Total</div>
              <div style={{ fontSize: 28, fontWeight: 700 }}>
                £ {Number(totalCash).toLocaleString()}
              </div>
            </div>

            {/* Hidden / Expanded Data */}
            {!isCollapsed && (
              <>
                <Row gutter={[12, 12]} style={{ marginTop: 14 }}>
                  <Col span={12}>
                    <Card
                      size="small"
                      style={{
                        borderRadius: 14,
                        background: "rgba(255,255,255,0.12)",
                        border: "none",
                      }}
                    >
                      <Statistic
                        title={
                          <span style={{ color: "#fff" }}>Cash Variance</span>
                        }
                        value={Number(lastData?.cash_have || 0).toFixed(2)}
                        prefix="£"
                        valueStyle={{ color: "#fff", fontSize: 20 }}
                      />
                    </Card>
                  </Col>

                  <Col span={12}>
                    <Card
                      size="small"
                      style={{
                        borderRadius: 14,
                        background: "rgba(255,255,255,0.12)",
                        border: "none",
                      }}
                    >
                      <Statistic
                        title={
                          <span style={{ color: "#fff" }}>Expected Cash</span>
                        }
                        value={Number(lastData?.cash_at_point || 0).toFixed(2)}
                        prefix="£"
                        valueStyle={{ color: "#fff", fontSize: 20 }}
                      />
                    </Card>
                  </Col>
                </Row>

                <div
                  style={{
                    marginTop: 14,
                    padding: 14,
                    borderRadius: 14,
                    background: "rgba(255,255,255,0.10)",
                    color: "#fff",
                  }}
                >
                  <CalendarOutlined /> Last Update:
                  <br />
                  <strong>
                    {lastData?.createdAt
                      ? new Date(lastData.createdAt).toLocaleString()
                      : "-"}
                  </strong>
                </div>
              </>
            )}
          </>
        )}
      </Card>

      {/* ================= HISTORY MODAL ================= */}
      <Modal
        title="Cash Variance History"
        open={open}
        onCancel={() => setOpen(false)}
        footer={null}
        width={1100}
      >
        <Row gutter={16} style={{ marginBottom: 18 }}>
          <Col span={8}>
            <Card
              style={{
                borderRadius: 16,
                background: "linear-gradient(135deg,#1677ff,#69b1ff)",
              }}
            >
              <Statistic
                title={<span style={{ color: "#fff" }}>Pending Total</span>}
                value={Number(totalCash).toFixed(2)}
                prefix="£"
                valueStyle={{ color: "#fff" }}
              />
            </Card>
          </Col>

          <Col span={8}>
            <Card style={{ borderRadius: 16 }}>
              <Statistic title="Records" value={pagination.totalRecords || 0} />
            </Card>
          </Col>

          <Col span={8}>
            <Card style={{ borderRadius: 16 }}>
              <Statistic title="Current Page" value={page} />
            </Card>
          </Col>
        </Row>

        <Row style={{ marginBottom: 15 }}>
          <Col span={24}>
            <RangePicker
              style={{ width: "100%" }}
              onChange={handleDateFilter}
              format="YYYY-MM-DD"
              allowClear
            />
          </Col>
        </Row>

        <Table
          rowKey="_id"
          columns={columns}
          dataSource={list}
          loading={loading}
          pagination={{
            current: page,
            pageSize: 10,
            total: pagination.totalRecords,
            onChange: (p) => loadList(p),
          }}
        />
      </Modal>

      {/* ================= EDIT MODAL ================= */}
      <Modal
        title="Update Adjustment"
        open={editOpen}
        onCancel={() => setEditOpen(false)}
        onOk={submitEdit}
        okText="Save Update"
      >
        <Form form={form} layout="vertical">
          <Form.Item label="Cash Variance" name="cash_have">
            <Input prefix={<WalletOutlined />} />
          </Form.Item>

          <Form.Item label="Expected Cash" name="cash_at_point">
            <Input prefix={<WalletOutlined />} />
          </Form.Item>

          <Form.Item label="Status" name="status">
            <Select
              options={[
                { label: "Pending", value: "false" },
                { label: "Resolved", value: "true" },
              ]}
            />
          </Form.Item>

          <Form.Item label="Notes" name="remarks">
            <TextArea rows={4} placeholder="Write Notes..." />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default CashAdjustmentCard;
